import { rem } from "polished";
export function createSize() {
    return function (size) {
        return rem(size);
    };
}
export default createSize;
//# sourceMappingURL=create-size.js.map